import * as React from 'react';
import { observer } from 'mobx-react';
import '../resources/color.css';

const bicc_center_left = require('../resources/bicc_center_left.jpg');
const bicc_center_right = require('../resources/bicc_center_right.jpg');
const bicc_center_outsite_left = require('../resources/bicc_center_outsite_left.jpg');
const bicc_center_outside_right = require('../resources/bicc_center_outside_right.jpg');

export const Venue = observer((props: {}) => (
    <div className="center">
      <div className="cf center">
        <div className="fl w-100">
          <p className="tc pv2 fw5 f2 bg_orange white">Venue</p>
        </div>
        <div className="mw9 center ph3-ns">
          <div className="cf ph2-ns">
            <div className="fl w-100 w-50-ns pa2">
              <img src={bicc_center_left} alt="bicc_center_left" className="" />
            </div>
            <div className="fl w-100 w-50-ns pa2">
              <img src={bicc_center_right} alt="bicc_center_right" className="" />
            </div>
          </div>
        </div>
        <div className="mw9 center ph3-ns pv5">
          <div className="cf ph2-ns">
            <div className="fl w-100 w-50-ns pa2">
              <img src={bicc_center_outsite_left} alt="bicc_center_outsite_left" className="" />
            </div>
            <div className="fl w-100 w-50-ns pa2">
              <img src={bicc_center_outside_right} alt="bicc_center_outside_right" className="" />
            </div>
          </div>
        </div>
        <div className="mw9 center ph3-ns">
          <div className="cf ph5-ns pb5">
            <div className="fl w-100 pa2">
              <p className=" pv3 b f4 f2-l">BANGABANDHU INTERNATIONAL CONFERENCE CENTER (BICC)</p>
            </div>
            <div className="fl w-100 pa2">
              <p className="fw4 f5 f4-l">The country’s only multi-purpose convention facility, Bangabandhu International Conference Center (BICC), has 17 (seventeen) venues for holding small to large scale events, state functions, social events, seminars, conferences, product launches, annual general meetings, fairs, exhibitions, cultural programs, reality shows, etc. BICC has been the venue for many renowned economic, social and cultural events. It has proudly hosted a number of international conferences and summits over the years.</p>
            </div>
            <div className="fl w-100 pa2">
              <p className="fw4 f5 f4-l">This modern convention center is surrounded by a spacious parking area, lawn, garden and musical fountain. The elevated roof and massive structure makes any event grand at its premises. As of 1 July 2012, Bangladesh Services Limited (BSL); owner of Ruposhi Bangla Hotel is looking after the operation, maintenance and management of BICC. BSL has a rich heritage of reputed service in hospitality industry of Bangladesh.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/Venue.tsx